/**
 * Calls callback immediately, after that, it only calls in regular intervals.
 * When it fires, it fires the most recent callback and drops intermediate callbacks.
 * @param cb Function to call throttled.
 * @param [delay=100] Delay in milliseconds.
 * @returns Throttled version of the passed in callback function
 */
export function throttle (cb: Function, delay = 100): Function {
    let lastFired = new Date(0);
    let timeout = null;
    
    return (...args) => {
        clearTimeout(timeout);
        const now = new Date();
        if ((now.getTime() - delay) > lastFired.getTime() ) {
            lastFired = now;
            cb(...args);
        } else {
            timeout = setTimeout(() => {
                lastFired = now;
                cb(...args);
            }, delay - (now.getTime() - lastFired.getTime()));
        }
    };
}
